export enum PeopleType {
  Member = 0,
  Contact = 1,
}
